import {HomePage} from "../pages/home-page";
import {AuthLayout, MainLayout} from "../components/layout";
import {ForgetPassword, Login, Register} from "./auth";
import {Privacy} from "./privacy";
import {Blog} from "./blog";
import {Profile} from "./profile";
import {EarlyAccess} from "./early-access";
import BlogView from "./blog/parts/BlogView";
import {Tutorials} from "./tutorials";
import TutorialView from "./tutorials/parts/TutorialView";
import MenuNotification from "./profile/parts/MenuNotification";

const routes = [
    {
        path: "/",
        Component: HomePage,
        Layout: MainLayout,
        secured: false,
    },
    {
        path: "/privacy",
        Component: Privacy,
        Layout: MainLayout,
        secured: false,
    },
    {
        path: "/blog",
        Component: Blog,
        Layout: MainLayout,
        secured: false,
    },
    {
        path: "/blog/:id",
        Component: BlogView,
        Layout: MainLayout,
        secured: false,
    },
    {
        path: "/early-access",
        Component: EarlyAccess,
        Layout: MainLayout,
        secured: false,
    },
    {
        path: "/tutorials",
        Component: Tutorials,
        Layout: MainLayout,
        secured: false,
    },
    {
        path: "/tutorial/:id/:subId",
        Component: TutorialView,
        Layout: MainLayout,
        secured: false,
    },
    // Auth components
    {
        path: "/auth/login",
        Component: Login,
        Layout: AuthLayout,
        secured: false,
    },
    {
        path: "/auth/register",
        Component: Register,
        Layout: AuthLayout,
        secured: false,
    },
    {
        path: "/auth/forget-password",
        Component: ForgetPassword,
        Layout: AuthLayout,
        secured: false,
    },
    {
        path: "/notification",
        Component: MenuNotification,
        Layout: AuthLayout,
        secured: true,
    },
    // Private pages
    {
        path: "/profile",
        Component: Profile,
        Layout: MainLayout,
        secured: true,
    },
];

export default routes;